<template>
  <div class="reply-tag" @click="showComment = !showComment">
    <i class="reply-icon fas fa-level-up"></i>
    <p class="tag-text">En respuesta a <span class="reply-num">#{{num}}</span></p>
    <transition name="modal-reply">
      <edi-replied-comment :comment="comment" v-if="showComment" />
    </transition>
  </div>
</template>

<script>
  import EdiRepliedComment from "./EdiRepliedComment";
  export default {
    components: {
      EdiRepliedComment
    },
    props: {
      comment: Object
    },
    data() {
      return {
        showComment: false,
      }
    },
    computed: {
      num() {
        return this.comment?.threadRelativeCommentId;
      }
    }
  }
</script>

<style scoped>
  .modal-reply-enter-active, .modal-reply-leave-active{
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .modal-reply-enter, .modal-reply-leave-to {
    opacity: 0;
  }
</style>